"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const names = ['Slime', 'Zombie', 'Egg', 'Penguin Knight', 'Dracula'];
const description = 'Description. '.repeat(5);
const colors = ['red', 'blue', 'green', 'yellow'];
const categories = [0, 1, 2];
function makeAsset() {
    return {
        id: `asset-${window.setTimeout(() => { }, 0)}`,
        name: random(names),
        description: description,
        color: random(colors),
        category: random(categories)
    };
}
exports.makeAsset = makeAsset;
function dummyAssets() {
    return Array.from({ length: 200 }).map(() => makeAsset());
}
exports.dummyAssets = dummyAssets;
function random(table) {
    const index = (Math.random() * table.length) >> 0;
    return table[index];
}
exports.random = random;
